import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { AuthConsumer } from './context/AuthContext'

const ProtectedRoute = ({ component: Component, ...rest }) => (
    <AuthConsumer>
        {({ isAuth }) => {
            if (!isAuth) {
                return (
                    <Route render={() => <Redirect to='/' />} />
                )
            } else {
                return (
                    <Route
                        render={props => <Component {...props} />}
                        {...rest}
                    />
                )
            }
        }}
    </AuthConsumer>
)

export default ProtectedRoute;